import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ToasterService } from '../../../core/services/toaster.service';
import { Toast } from '../../../core/models/toast';
import { ToasterComponent } from '../../../core/components/toaster/toaster.component';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-toaster-container',
  imports: [
    ToasterComponent,
  ],
  templateUrl: './toaster-container.component.html',
  styleUrl: './toaster-container.component.scss'
})
export class ToasterContainerComponent implements OnInit {
  toasts: Toast[] = [];

  constructor(protected toaster: ToasterService, @Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit() {
    this.toaster.toast$
      .subscribe(toast => {
        if (isPlatformBrowser(this.platformId)) {
          this.toasts = [toast, ...this.toasts];
          setTimeout(() => this.toasts.pop(), toast.delay || 6000);
        }
      });
  }

  remove(index: number) {
    this.toasts = this.toasts.filter((v, i) => i !== index);
  }
}
